import { all, fork } from 'redux-saga/effects';

import { oldDashboardSaga } from './OldDashboard';
import { dashboardPageSaga } from './DashboardPage';
import { billingSaga } from './Billing';
import { billingDetailsSaga } from './BillingDetails';
import { passwordPageSaga } from './PasswordPage';
import { mobileNumberPageSaga } from './MobileNumberPage';
import { policySaga } from './Policy';
import { otpLinkSaga } from './OtpLink';
import { claimSaga } from './Claim';
import { ClaimDetailsSaga } from './ClaimDetails';
import { claimEditSaga } from './ClaimEdit';
import { claimEditModalSaga } from './ClaimEditModal';
import { userClaimAdditionalDocumentsSaga } from './ClaimAdditionalDocuments';
import { PolicyClaimSaga } from './PolicyClaim';
import { policyDetailsSaga } from './PolicyDetails';
import { policyRenewalSaga } from './PolicyRenewal';
import { personalInfoEditSaga } from './PersonalInfoEditPage';
import { searchCorporateMemberSaga } from './SearchCorporateMember';
import { insurancePolicyListPageSaga } from './InsurancePolicyListPage';
import { insurancePolicyDetailsPageSaga } from './InsurancePolicyDetailsPage';
import { insurancePolicyUserDetailsPageSaga } from './InsurancePolicyUserDetailsPage';
import { commissionListSaga } from './CommissionList';
import { searchInsurancePolicyUserPageSaga } from './SearchInsurancePolicyUserPage';

export default function* () {
  yield all([
    fork(oldDashboardSaga),
    fork(dashboardPageSaga),
    fork(billingSaga),
    fork(billingDetailsSaga),
    fork(passwordPageSaga),
    fork(mobileNumberPageSaga),
    fork(personalInfoEditSaga),
    fork(policySaga),
    fork(claimSaga),
    fork(ClaimDetailsSaga),
    fork(userClaimAdditionalDocumentsSaga),
    fork(PolicyClaimSaga),
    fork(policyDetailsSaga),
    fork(policyRenewalSaga),
    fork(otpLinkSaga),
    fork(claimEditSaga),
    fork(claimEditModalSaga),
    fork(searchCorporateMemberSaga),
    fork(insurancePolicyListPageSaga),
    fork(insurancePolicyDetailsPageSaga),
    fork(insurancePolicyUserDetailsPageSaga),
    fork(commissionListSaga),
    fork(searchInsurancePolicyUserPageSaga),
  ]);
}
